export const absoluteURL = (url) => {
    return process.env.PUBLIC_URL + url
}

// Return only digits from the provided phone string. Removes spaces, '+', and all non-digits.
export const sanitizePhoneDigitsOnly = (phone) => {
    const raw = phone == null ? "" : String(phone)
    return raw.replace(/\D+/g, "")
}

export const toLowercaseName = (name) => {
    const raw = name == null ? "" : String(name)
    return raw.trim().toLowerCase()
}